// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LMct","left":"styles_left__FeO3_","desktopActions":"styles_desktopActions__Bs111","title":"styles_title__i3LIr"};